import React from 'react';
import './AboutContactCTA.css';

const ContactCTA = () => {
  return (
    <section className="cta-section">
      <div className="cta-container">
        <h2 className="cta-heading">Ready to build something that matters?</h2>
        <p className="cta-email">info@vcnrworld.com</p>
        <a href="/Contact" className="explore-btn">Contact us</a>
      </div>
    </section>
  );
};

export default ContactCTA;
